module.exports = __webpack_public_path__ + "static/extrade-bf748f5b030360349361b48f9229eb94.png";